import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type MainMenuState = {
	isOpen: boolean
}

const initialState: MainMenuState = {
	isOpen: false,
}

export namespace MainMenuNS {
	export type setMenuClose = PayloadAction
	export type setMenuToggle = PayloadAction
}

export const mainMenuSlice = createSlice({
	name: 'menu',
	initialState,
	reducers: {
		setMenuClose: (state, action: MainMenuNS.setMenuClose) => {
			state.isOpen = false
		},
		setMenuToggle: (state, action: MainMenuNS.setMenuToggle) => {
			state.isOpen = !state.isOpen
		},
	},
})
